<template>

        <!-- About Us Header with Background Image -->
        <section class="about-header text-center mt-0" style="background: url('/images/insidegym8.jpg') no-repeat center center; background-size: cover; padding: 50px 0; color: #fff;">
      <h1 class="display-4 font-weight-bold">CONTACT US</h1>
      <!-- <p class="lead">Soldiers Gym aims to bring ‘next-generation fitness’ with top-notch specialized workout facilities and training programs for all members.</p> -->
    </section>

  <section class="contact-us mt-5">
    <div class="container">
      <div class="row">
        <!-- Left Side: Address and Contact Info -->
        <div class="col-md-6">
          <h3>Get in Touch!</h3>
          <p>
            <strong>Address:</strong><br />
            Soldier's Gym<br />
            Pragathi Complex, Above SBH Bank, Sadhashiv Nagar Attibele,
            <br />
            Bengaluru, Karnataka - 562107 <br />
            India
          </p>
          <p>
            <strong>Phone:</strong><br />
            +91 99522 96949
          </p>
          <p>
            <strong>Email:</strong><br />
            info@soldiergym.com
          </p>
        </div>

        <!-- Right Side: Contact Form -->
        <div class="col-md-6">
          <h3>Contact Us</h3>
          <form @submit.prevent="submitForm">
            <div class="form-group">
              <label for="name">Name*</label>
              <input type="text" id="name" v-model="form.name" class="form-control" required />
            </div>

            <div class="form-group">
              <label for="email">Email*</label>
              <input type="email" id="email" v-model="form.email" class="form-control" required />
            </div>

            <div class="form-group">
              <label for="phone">Phone Number</label>
              <input type="tel" id="phone" v-model="form.phone" class="form-control" />
            </div>

            <div class="form-group">
              <label for="message">Message</label>
              <textarea id="message" v-model="form.message" class="form-control" rows="4"></textarea>
            </div>

            <button type="submit" class="btn btn-primary">Submit</button>
          </form>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "ContactUsPage",
  data() {
    return {
      form: {
        name: "",
        email: "",
        phone: "",
        message: "",
      },
    };
  },
  methods: {
    submitForm() {
      console.log("Form Submitted: ", this.form);
      this.form.name = "";
      this.form.email = "";
      this.form.phone = "";
      this.form.message = "";
      alert("Thank you for reaching out to SoldierGym!");
    },
  },
};
</script>

<style scoped>

.about-header h1 {
  font-size: 3rem;
  font-weight: 700;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.6);
}

.about-header p {
  font-size: 1.25rem;
  color: #fff;
}

.about-content img {
  border: 5px solid #f2b705;
  box-shadow: 0 8px 15px rgba(0, 0, 0, 0.2);
  margin-bottom: 30px;
}

.about-content p {
  font-size: 1.15rem;
  color: #555;
  line-height: 1.8;
  margin-bottom: 20px;
}
/* Styling for Contact Us Section */
.contact-us {
  padding: 60px 20px;
  background-color: #f8f9fa; /* Light gray background for subtle contrast */
  border-radius: 10px;
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.1); /* Soft shadow for a clean look */
}

.contact-us h2 {
  font-size: 2.5rem;
  color: #ffc107; /* Warm color from theme */
  font-weight: 700;
  margin-bottom: 25px;
  text-transform: uppercase;
}

.contact-us p {
  font-size: 1.1rem;
  color: #555;
  margin-bottom: 15px;
}

.contact-us h3 {
  font-size: 2rem;
  color: #000000 ;
  margin-bottom: 20px;
  font-weight: 700;
}

.contact-us .form-group {
  margin-bottom: 20px;
}

.contact-us .form-group label {
  font-size: 1.1rem;
  color: #333;
  font-weight: 600;
}

.contact-us .form-control {
  border-radius: 8px;
  border: 1px solid #ddd;
  padding: 12px;
  width: 100%;
  font-size: 1rem;
  box-sizing: border-box;
}

.contact-us .form-control:focus {
  border-color: #ffc107 ; /* Highlight input field with theme color */
  outline: none;
  box-shadow: 0 0 5px rgba(217, 126, 30, 0.3);
}

.contact-us .btn-primary {
  background-color: #ffc107 ;
  border-color: #ffc107 ;
  color: white;
  padding: 12px 25px;
  border-radius: 6px;
  font-size: 1.1rem;
  font-weight: 600;
  text-transform: uppercase;
  transition: background-color 0.3s ease, transform 0.3s ease;
}

.contact-us .btn-primary:hover {
  background-color: #ffc107 ; /* Darker shade for hover */
  transform: translateY(-3px);
}

.contact-us .btn-primary:focus {
  box-shadow: 0 0 5px rgba(217, 126, 30, 0.4);
}

/* Responsive Design */
@media (max-width: 767px) {
  .contact-us .row {
    flex-direction: column;
  }

  .contact-us .col-md-6 {
    margin-bottom: 30px;
  }

  .contact-us h2 {
    font-size: 2.2rem;
  }

  .contact-us h3 {
    font-size: 1.7rem;
  }

  .contact-us .form-group label {
    font-size: 1rem;
  }

  .contact-us .form-control {
    font-size: 1rem;
  }

  .contact-us .btn-primary {
    font-size: 1rem;
    padding: 10px 20px;
  }
}
</style>
